import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ICompanyGroup, IDbTask } from 'bets.oddprovider.lib.common.ts/models'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import axios from '../../apiClient/axios'
import { CompaniesGroupsApiClient } from '../../apiClient/companiesGroups'
import { TasksApiClient } from '../../apiClient/tasks'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'

export interface IDbTasksAction extends IDefaultAction {
  payload?: IDbTask[],
  companiesGroups?: ICompanyGroup[]
}

export interface IDbTasksState extends IDefaultState {
  payload?: IDbTask[],
  companiesGroups?: ICompanyGroup[]
}

const initState: IDbTasksState = {}

export const dbTasksStateLoadFromApi = createAsyncThunk(
  'dbTasksStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<IDbTask>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {
    const tasksApiResult: IApiClientResult<ApiResponseGetListData<IDbTask>> = await new TasksApiClient(axios).get({
      where: arg.where,
      sort: { active: 1, name: 1 }
    })

    const companiesApiResult = await new CompaniesGroupsApiClient(axios).get({
      nested: 'companies{company}',
      sort: { name: 1 }
    })
    let companiesGroups: ICompanyGroup[] | undefined = companiesApiResult.data?.payload
    companiesGroups = companiesGroups?.filter(cg => cg.companies?.length).map(cg => ({
      ...cg,
      companies: cg.companies?.sort((a, b) => {
        const nameA = a.company?.name || '';
        const nameB = b.company?.name || '';
        return nameA.localeCompare(nameB);
      })
    })) ?? [];

    if (tasksApiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(tasksApiResult.msg)

    if (arg.onFinally)
      arg.onFinally()

    return {
      tasksApiResult,
      companiesGroups,
    }
  }
)

export const dbTasksSlice = createSlice({
  name: 'tasksSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(dbTasksStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(dbTasksStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.tasksApiResult.data?.payload
      state.companiesGroups = response.payload.companiesGroups
    })
    builder.addCase(dbTasksStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const { clear: clearDbTasks } = dbTasksSlice.actions
export default dbTasksSlice.reducer